import {
  HttpRequest,
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpResponse
} from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { Observable, of } from "rxjs";
import {
  FilePickerAdapter,
  UploadResponse,
  UploadStatus,
  FilePreviewModel
} from "ngx-awesome-uploader";
import { FormGroup } from "@angular/forms";

export class MyPickerAdapterService extends FilePickerAdapter {
  constructor(
    private http: HttpClient,
    private apiBaseUrl: string,
    private myForm: FormGroup
  ) {
    super();
  }

  public uploadFile(fileItem: FilePreviewModel): Observable<UploadResponse> {
    let form = new FormData();
    form.append("file", fileItem.file);
    form.append("indice", this.myForm.get("i").value);

    const api = this.apiBaseUrl;
    const req = new HttpRequest("POST", api, form, { reportProgress: true });

    return this.http.request(req).pipe(
      map((res: HttpEvent<any>) => {
        if (res.type === HttpEventType.Response) {
          const responseFromBackend = res.body;
          return {
            body: responseFromBackend,
            status: UploadStatus.UPLOADED
          };
        } else if (res.type === HttpEventType.UploadProgress) {
          /** Compute and show the % done: */
          const uploadProgress = +Math.round((100 *
          res.loaded) / res.total);
          return {
            status: UploadStatus.IN_PROGRESS,
            progress: uploadProgress
          };
        }
      }),
      catchError(er => {
        return of({ status: UploadStatus.ERROR, body: er });
      })
    );
  }


  public removeFile(fileItem: FilePreviewModel): Observable<any> {
    const id = 50;
    const responseFromBackend = fileItem.uploadResponse;

    for (let i = 0; i <= +this.myForm.get("i").value; i++) {
      const actGroup = <FormGroup>this.myForm.controls['items'].get(i+"");
      if (actGroup.controls['cc'].value == responseFromBackend.cc) {
        actGroup.controls['base64'].setValue("");
        actGroup.controls['filename'].setValue("");
        actGroup.controls['cc'].setValue("");

        break;
      }
    }

    return of(new HttpResponse({status: 200}));
  }
}
